module.exports = "<div id=\"wind-column\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/sketch/wind-columns/wind-columns.component.html
// module id = 57
// module chunks = 0